import {css} from "@emotion/react";

export const title = css`
    padding: 24px 24px;
    width: 900px;
`;

export const titleTable = css`
    padding: 24px 24px;
    padding-left: 0px;
    width: 900px;
`;
